import get from 'lodash.get';

export const selectSso = state => get(state, 'models.sso.data');
export const selectUbiquitiEmail = state => get(selectSso(state), 'email');
export const selectUbiquitiUsername = state => get(selectSso(state), 'username');

export const selectDefaultMfaId = state => get(selectSso(state), 'default_mfa');
export const selectAuthenticators = state => get(selectSso(state), 'authenticators');
